// Shared constants for the Settings page and its extracted card components.
//
// Lifted out of Settings.tsx during the 2026-05-01 split so BookingPageCard
// and BrandingCard can import these without circular dependencies. No values
// changed — pure relocation.

import { DayOfWeek, InspectorAvailabilityDay } from '@/types';

export const TIMEZONE_OPTIONS = [
  'America/Los_Angeles',
  'America/Denver',
  'America/Phoenix',
  'America/Chicago',
  'America/New_York',
  'America/Anchorage',
  'Pacific/Honolulu',
  'UTC',
];

export const detectBrowserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';
  } catch {
    return 'America/Los_Angeles';
  }
};

export const DAYS_OF_WEEK: { value: DayOfWeek; label: string }[] = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

// One row per day-of-week, indexed by `value`. Defaults to Mon–Fri 9–5
// when the inspector has nothing saved yet.
export const DEFAULT_AVAILABILITY: InspectorAvailabilityDay[] = [
  { dayOfWeek: 0, startTime: '09:00', endTime: '17:00', isActive: false },
  { dayOfWeek: 1, startTime: '09:00', endTime: '17:00', isActive: true },
  { dayOfWeek: 2, startTime: '09:00', endTime: '17:00', isActive: true },
  { dayOfWeek: 3, startTime: '09:00', endTime: '17:00', isActive: true },
  { dayOfWeek: 4, startTime: '09:00', endTime: '17:00', isActive: true },
  { dayOfWeek: 5, startTime: '09:00', endTime: '17:00', isActive: true },
  { dayOfWeek: 6, startTime: '09:00', endTime: '17:00', isActive: false },
];

// Flowspect brand green — used whenever a user hasn't picked their own color.
export const DEFAULT_BRAND_COLOR = '#2F6A44';
export const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export const ENTITY_TYPE_OPTIONS = [
  '',
  'Sole proprietor',
  'LLC',
  'S-corporation',
  'C-corporation',
  'Partnership',
  'Other',
];
